<template>
    <div class="animated fadeIn create_footer desktop_padding_bottom_zero">
        <div class="create-new-job-section email-template-section">
            <div id="breadcrumb-v2" class="mb-1">
                <div class="d-flex justify-content-start breadcrumb-wrapper">
                    <b-breadcrumb
                    :items="breadCrumb()"
                    />
                </div>
            </div>

            <div class="manage-job-section" v-if="job">
            <div class="black-strip-head d-lg-flex d-sm-flex align-items-center">
                <h3 class="mr-auto">{{job['title']}} ({{job['job_unique_id']}})</h3>
            
            </div>
        </div>
           
            <!-- Loop Start -->

            

                <div class="edit-profile-section border-radius-4 white-bg common_padding_30 commmon_label_heading loop_div">
                        <div class="edit-form-box desktop_margin_top_zero">
                            <div v-for="item in items" :key="item">
            <div  class="profile-section p-lg-5 p-3 white-bg view_audit_top_div">
                <div class="profile-box pl-0">
                    <div class="profile-detail">
                        <ul>
                            <li v-if="item.process" class="pl-0 desktop_margin_top_zero">
                                <p><b>Process</b>- <i> {{item.process | capitalize}} </i></p>
                            </li>
                            <li v-if="item.api" class="pl-0">
                                <p><b>Api</b>- <i> {{item.api}} </i></p>
                            </li>
                            <li v-if="item.process_log" class="pl-0">
                                <p><b>Process Log</b>- <i> {{item.process_log}}</i></p>
                            </li>
                            <li v-if="item.updated_at" class="pl-0">
                                <p><b>Updated At</b>- <i> {{item.updated_at | moment}}</i></p>
                            </li>
                            <li v-if="item.updated_by" class="pl-0">
                                <p><b>Updated By</b>- <i> {{(item.updated_by != null ? item.updated_by.full_name : '-') | capitalize}}</i></p>
                            </li>
                            <li v-if="item.process" class="pl-0">
                                <p><b>FL/User ID</b>- <i> {{(item.user_id != null ? item.user_id.full_name : 'By System') | capitalize}} </i></p>
                            </li>
                            
                        </ul>
                    </div>
                </div>
            </div>
            <br>
        </div>
                        </div>
                </div>

               

             <!-- Loop End -->
        </div>
    </div>
</template>

<script>

import { POST_API, GET_API } from "../../../store/actions.type";


export default {

data() {
        return {
            fields: [
                { key: 'process', label: 'Process', sortable: true, thStyle:  {width: '5%'}},
                { key: 'api', label: 'Api', sortable: true, thStyle:  {width: '5%'}},
                { key: 'process_log', label: 'Process Log', sortable: true, thStyle:  {width: '5%'}},
                { key: 'status', label: 'Status', sortable: true, thStyle:  {width: '5%'}},
                { key: 'updated_on', label: 'Updated On', sortable: true, thStyle:  {width: '7%'} },
                { key: 'updated_by', label: 'Updated By', sortable: true, thStyle:  {width: '5%'}},
            ],
            form: {
                rowsPerPage: 25,
                userServices: 'all',
            },
            items: null,
            transactions:null,
            userDetail:null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 75, 100],
            sortBy: null,
            sortDirection: 'asc',
            filter: null,
            status: 'active',
            isBusy: false,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            to: '',
            from: '',
            country:'',
            countries:'',
            Country:'',
            webUrl: process.env.MIX_APP_URL,
            id: this.$route.params.id,
            job:'',
            user_id:'',
            logged_user_id:''

        }
    },
    filters: {
        capitalize: function(value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        filtercapitalize:function(value){
          if (!value) return ''
          value = value.toString()
          value = value.replace('_',' ');
          return value.charAt(0).toUpperCase() + value.slice(1)
        },
        
        moment: function(date) {
          if (date == null || date == "") return "-";
            return moment(date).format('DD MMM, YYYY hh:mm A')
        },
    },
    components: {
        
    },
    methods: {
        breadCrumb(){
            var item = [{
                to:{name:'dp-jobs'},
                text: 'Manage Jobs',
            },{
                to:null,
                text: 'View Audit Job'
            }];
            return item;
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        
        getDetail() {
            return this.$store.dispatch(POST_API, {
                    data: {
                        page: this.currentPage,
                        keyword: this.filter,
                        rowsPerPage: this.form.rowsPerPage,
                        sortBy: this.sortBy,
                        sortDirection: this.sortDirection,
                        sortDesc: this.sortDesc,
                        job_id:btoa(this.$route.params.id),
                        userId:this.logged_user_id

                    },
                    api: '/api/audit-job-details'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                        return [];
                    } else {
                        this.items = this.$store.getters.getResults.data.data;
                        this.job = this.$store.getters.getResults.data.job;
                        
                        return this.items;
                    }
                });
        },

        
    },
    mounted()
    {

         this.user_id =
      this.$store.getters.currentUser != null ? this.$store.getters.currentUser.id : "";
    this.logged_user_id =
      this.$store.getters.currentUser != null ? this.$store.getters.currentUser.id : "";
        $(".dashboard-content-container .simplebar-scroll-content").animate({ 
            scrollTop: 0 
        }, "fast");
        this.getDetail();
    }
};

</script>
